import styled from 'styled-components'

const H5 = styled.h5`
  font-family: 'Montserrat', sans-serif;
  margin: 0;
  font-size: 1.1em;
`
export default H5
